<template>

    <div>       
        <v-layout row justify-center="">
            <v-flex xs4>
                <v-select
                label="Formulier type"
                :items="form.templates"
                item-text="name"
                item-value="reference"
                v-model="form.reference"
                required=""
                >
                </v-select>
            </v-flex>
            <v-flex xs6 offset-xs1>            
                <v-text-field
                append-icon="mdi-magnify"
                single-line=""
                :color="app.color"
                hide-details=""
                v-model="search"
                ></v-text-field>
            </v-flex>
        </v-layout>

        <v-data-table
        style="min-height:500px"
        show-select
        disable-pagination
        hide-default-footer
        :search="search"
        :items="items"
        :headers="objectHeaders"
        item-key="reference">

            <template slot="header.data-table-select" slot-scope="props">

                <!-- <tr>
                    <td> -->
                        <v-checkbox :disabled="disableCheckAll" :value="emptyOrFull()" @change="addOrDeleteAll()" color="success" ></v-checkbox>
                    <!-- </td>

                    <td v-for="(head, i) in objectHeaders">
                        {{head.text}}
                    </td>      -->
                   
                <!-- </tr> -->


                
            </template>
                    


              <template
                v-slot:item="props"
              >
              <tr class="selectorRow">
                <td>
                    <v-layout>
                        <v-checkbox class="pa-0 ma-0" :value="hasValue(props.item.reference)" @change="addToReferences(props.item.reference)" hide-details=""  color="success"></v-checkbox>
                    </v-layout>
                </td>
                <td v-for="(n,index) in objectHeaders" :key="index">
                  
                  <span>{{props.item[n.value]}}</span>
                  <!-- <span v-if="props.item[n.value] !== true && props.item[n.value] !== false">{{props.item[n.value]}}</span>
                  <v-icon v-if="props.item[n.value] === true" color="success">mdi-check</v-icon>
                  <v-icon v-if="props.item[n.value] === false" color="error">mdi-close</v-icon>
                   -->
                </td>
            </tr>
              </template>


        </v-data-table>

    <v-layout justify-space-around class="pt-10 pb-10">
        <v-flex xs4 class="text-center">
            <v-btn block rounded color="warning" @click="form.create = false" >Annuleren</v-btn>
        </v-flex>
        <v-flex xs4 class="text-center">
            <v-btn block rounded color="success" :disabled="!valid" @click="createForms()" >Aanmaken</v-btn>
        </v-flex>
      </v-layout>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      selected: [],
      search: "",
      selected_object: null
    };
  },
  computed: {
    ...mapState(["objects", "form", "app", "types"]),
    items() {
      if (this.form.reference != "") {
        var object = this.form.templates.filter(
          item => item.reference == this.form.reference
        );
        var list = this.objects.filter(
          item => item.category.reference == object[0].object
        );
        // console.log(list);
        var output = [];
        for (var i = 0; i < list.length; i++) {
          var item = {};
          item = list[i].details;
          item["reference"] = list[i].reference;
          output.push(item);
        }
        console.log(output);
        return output;
      } else {
        return [];
      }

      //console.log(this.selected_object);
      if (this.selected_object != null) {
        var list = this.objects.filter(
          item => item.category.reference == this.selected_object[0].object
        );
        console.log(list);

        return list;
      } else {
        return [];
      }
    },
    disableCheckAll() {
      if (this.search == "") {
        return false;
      } else {
        return true;
      }
    },
    objectHeaders() {
      if (this.form.reference != "") {
        var object = this.form.templates.filter(
          item => item.reference == this.form.reference
        );
      } else {
        //console.log("undefined reference", this.form.reference);
      }

      if (object != undefined) {
        var res = this.types.filter(item => item.reference == object[0].object);
        console.log("res", res[0].headers);
        return res[0].headers;
      } else {
        return [];
      }
    },
    valid() {
      if (this.selected.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    emptyOrFull() {
      if (this.selected.length == 0) {
        return false;
      } else if (this.selected.length == this.items.length) {
        return true;
      }
    },
    addToReferences(reference) {
      var index = this.selected.indexOf(reference);
      //console.log("index", index);

      if (index < 0) {
        this.selected.push(reference);
      } else if (index >= 0) {
        this.selected.splice(index, 1);
      }
    },
    addOrDeleteAll() {
      if (this.selected.length > 0) {
        this.selected = [];
      } else {
        this.selected = [];
        for (var i = 0; i < this.items.length; i++) {
          this.selected.push(this.items[i].reference);
        }
      }
    },
    hasValue(reference) {
      if (this.selected.indexOf(reference) >= 0) {
        return true;
      } else {
        return false;
      }
    },
    createForms() {
      //console.log(this.selected, this.form.reference);
      this.$store.dispatch("createForm", {
        objects: this.selected
      });
    }
  },
  watch: {
    selected_object() {
      //console.log(this.selected_object);
    },
    selected() {
      console.log(this.selected);
    },
    items() {
      this.selected = [];
    },
    search() {
      this.selected = [];
    }
  }
};
</script>
